// ConnectionIndicator — extraído de Header.jsx en P3.1 refactor (feb-2026).
// Indicador visual "blip" azul que marca conexión activa.
const ConnectionIndicator = ({ t }) => (
  <div
    className="relative flex items-center justify-center"
    title={t('dashboard.connected') || 'Conectado'}
  >
    <span className="absolute inline-flex h-3 w-3 rounded-full bg-blue-400 opacity-75 animate-ping"></span>
    <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-blue-500 shadow-lg shadow-blue-500/50"></span>
  </div>
);

export default ConnectionIndicator;
